﻿import { sitecore } from '../../Foundation';

export class AudioPlayer {
  /**
   * Atom for playing audio-files within spots eg.
   * @param {HTMLElement} element
   */
  constructor(element) {
    element.AudioPlayer = this;

    // Disable component in experience editor mode
    if (sitecore.isInPageEditor) return false;

    // Normal mode
    this._refs = {
      el: element,
      play: element.querySelector('.audio-player__control'),
      text: element.querySelector('.audio-player__control-text'),
      switch: element.querySelector('.audio-player__swap-audio'),
      switchLabel: element.querySelector('.audio-player__switch-text'),
      audio: {
        primary: element.querySelector('.audio-player__source--primary'),
        secondary: element.querySelector('.audio-player__source--secondary'),
      },
      timeline: element.querySelector('.audio-player__timeline'),
      time: element.querySelector('.audio-player__time'),
      duration: element.querySelector('.audio-player__duration'),
      progress: element.querySelector('.audio-player__progress'),
    };

    this._props = {
      currentAudio: null,
    };

    // # Events
    if (this._refs.audio.primary.duration) {
      // Set duration, since we're already have it handy
      this._onAudioLoad();
    } else {
      // Wait for meta data to be loadd
      if (this._refs.audio.primary) {
        this._refs.audio.primary.addEventListener('loadedmetadata', this._onAudioLoad.bind(this));
      }
    }

    // Timeline events
    if (this._refs.audio.primary) {
      this._refs.audio.primary.addEventListener('timeupdate', this._onAudioTimeUpdate.bind(this));
      this._refs.audio.primary.addEventListener('ended', this._onAudioEnded.bind(this));
    }

    // Manual events
    if (this._refs.switch != null) {
      const oCheckbox = this._refs.switch.querySelector('input[type="checkbox"]');
      if (oCheckbox != null) {
        oCheckbox.addEventListener('click', this._onSwitchToggl.bind(this));
      }
    }

    if (this._refs.play != null) {
      this._refs.play.addEventListener('click', this._onPlayClick.bind(this));
    }
  }

  /**
   * When Element has been created, populate element with additional information
   */
  _onAudioLoad() {
    const currentDuration = this._refs.audio.primary.duration;
    this._refs.duration.innerHTML = this._convertToTime(currentDuration);
  }

  /**
   * When an audio has ended, reset player to starting point
   */
  _onAudioEnded() {
    for (let x in this._refs.audio) {
      const oAudio = this._refs.audio[x];

      oAudio.pause();
      oAudio.currentTime = 0;

      this._refs.text.innerHTML = this._refs.text.dataset.play;
      this._refs.play.classList.remove('is-playing');
    }
  }

  /**
   * Update current time played for element
   */
  _onAudioTimeUpdate() {
    this._refs.time.innerHTML = this._convertToTime(this._refs.audio.primary.currentTime);
    this._refs.progress.style.width =
      (this._refs.audio.primary.currentTime / this._refs.audio.primary.duration) * 100 + '%';
  }

  /**
   * Handler for switching between 2 audiofiles in player
   * @param {Event} e - Event Interface
   */
  _onSwitchToggl(e) {
    const switchToSecondary = e.target.checked,
      /* eslint-disable-next-line */
      oAudio = this._refs.audio.primary.playing
        ? this._refs.audio.primary
        : this._refs.audio.secondary;

    // TODO IN  CASE USER SWITCHES WITHOUT STUFF PLAYING

    if (switchToSecondary) {
      this._refs.audio.primary.muted = true;
      this._refs.audio.secondary.muted = false;

      if (this._refs.switchLabel.dataset.off != null && this._refs.switchLabel.dataset.off != '') {
        this._refs.switchLabel.innerText = this._refs.switchLabel.dataset.off;
      }
    } else {
      this._refs.audio.secondary.muted = true;
      this._refs.audio.primary.muted = false;

      if (this._refs.switchLabel.dataset.on != null && this._refs.switchLabel.dataset.on != '') {
        this._refs.switchLabel.innerText = this._refs.switchLabel.dataset.on;
      }
    }
  }

  /**
   * Play/Pausea audiofile
   */
  _onPlayClick() {
    for (let x in this._refs.audio) {
      const oAudio = this._refs.audio[x];

      if (oAudio.paused) {
        oAudio.play();

        // Swap text & icon
        this._refs.text.innerHTML = this._refs.text.dataset.pause;
        this._refs.play.classList.add('is-playing');
      } else {
        oAudio.pause();

        // Swap text & icon
        this._refs.text.innerHTML = this._refs.text.dataset.play;
        this._refs.play.classList.remove('is-playing');
      }
    }
  }

  /**
   * Convert a second-based string into a complete time-string
   * @param {String} length
   * @returns {String}
   */
  _convertToTime(currentTime) {
    /* eslint-disable-next-line */
    var current_hour = parseInt(currentTime / 3600) % 24,
      current_minute = parseInt(currentTime / 60) % 60,
      current_seconds_long = currentTime % 60,
      current_seconds = current_seconds_long.toFixed(),
      current_time =
        (current_minute < 10 ? '0' + current_minute : current_minute) +
        ':' +
        (current_seconds < 10 ? '0' + current_seconds : current_seconds);

    return current_time;
  }
}
